module.exports = __webpack_public_path__ + "webwave-2.png?c963ed0caf907de4ea8bae2b304f1dde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/webwave-2.png
// module id = 7YeU
// module chunks = 50